export function DotsIcon(): JSX.Element {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="3" cy="10" r="2" fill="#12192B" />
      <circle cx="10" cy="10" r="2" fill="#12192B" />
      <circle cx="17" cy="10" r="2" fill="#12192B" />
    </svg>
  );
}
